// Firestore (metadata) + DigitalOcean Spaces (files) data layer for the
// public "Articles" feature. Schema mirrors src/data/posts.js (the audit
// posts) so ArticleDetail can reuse the same rendering/theming as BlogPost.
import {
  collection,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
} from "firebase/firestore";
import { db } from "./firebase";
import { sanitizeFileName, uploadToSpaces } from "./doSpaces";

const ARTICLES_COLLECTION = "articles";

export async function listArticles() {
  const snap = await getDocs(
    query(collection(db, ARTICLES_COLLECTION), orderBy("createdAt", "desc")),
  );
  return snap.docs.map((d) => d.data());
}

export async function getArticleBySlug(slug) {
  const snap = await getDoc(doc(db, ARTICLES_COLLECTION, slug));
  return snap.exists() ? snap.data() : null;
}

// Article doc ID == slug, so it's also the read key and enforces uniqueness.
export async function createArticle(article) {
  await setDoc(doc(db, ARTICLES_COLLECTION, article.slug), {
    ...article,
    createdAt: serverTimestamp(),
  });
}

// Uploads a file to DigitalOcean Spaces under articles/{slug}/{folder}/{filename}
// and returns its public URL. `folder` groups cover/images/pdf within the article.
export async function uploadArticleFile(file, slug, folder) {
  const key = `articles/${slug}/${folder}/${sanitizeFileName(file.name)}`;
  return uploadToSpaces(file, key);
}
